import React, { useCallback } from 'react';

import { useIntl } from 'react-intl-next';

import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { ToolbarButton, ToolbarTooltip } from '@atlaskit/editor-toolbar';
import RandomizeIcon from '@atlaskit/icon-lab/core/randomize';

import type { MalleableUiPlugin } from '../../malleableUiPluginType';
import { messages } from '../messages';

const testId = 'editor-toolbar__remix-button';

interface RemixButtonProps {
	api: ExtractInjectionAPI<MalleableUiPlugin>;
}

export const RemixButton = ({ api }: RemixButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const handleClick = useCallback(() => {
		api?.core.actions.execute(api?.malleableUi.commands.openRemixModal());
	}, [api]);

	return (
		<ToolbarTooltip content={formatMessage(messages.remixToolbarTooltip)}>
			<ToolbarButton
				iconBefore={<RandomizeIcon label="" size="small" />}
				testId={testId}
				onClick={handleClick}
			>
				{formatMessage(messages.remixToolbarLabel)}
			</ToolbarButton>
		</ToolbarTooltip>
	);
};
